export const ONE_CUE_EVERY = 1500;

export type Burst = { soundedAt: number | null; held: number };

export const QUIET: Burst = { soundedAt: null, held: 0 };

export function offered(burst: Burst, now: number): { burst: Burst; play: boolean } {
  if (burst.soundedAt === null || now - burst.soundedAt >= ONE_CUE_EVERY) {
    return { burst: { soundedAt: now, held: 0 }, play: true };
  }
  return { burst: { ...burst, held: burst.held + 1 }, play: false };
}

export function closesAt(burst: Burst): number | null {
  if (burst.soundedAt === null || burst.held === 0) return null;
  return burst.soundedAt + ONE_CUE_EVERY;
}

export function closed(burst: Burst, now: number): { burst: Burst; summary: number } {
  const shuts = closesAt(burst);
  if (shuts === null || now < shuts) return { burst, summary: 0 };
  return { burst: { soundedAt: now, held: 0 }, summary: burst.held };
}
